// Loading.js
import React from 'react';

const Loading = ({ message }) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-800 bg-opacity-50 z-50">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-orange-master"></div>
        <p className="mt-4 text-orange-master">{message}</p>
      </div>
    </div>
  );
};

export default Loading;
